import React from 'react';

import { PrivacyPolicy } from 'components/privacy-policy';

export const PrivacyPolicyPage: React.FC = () => <PrivacyPolicy />;
